import type { ReactNode } from 'react';
import { CardUI } from '../CardUI.js';
import { useI18n } from '../../i18n.js';

export interface LandingHeroProps {
  children?: ReactNode;
}

const HERO_FAN_CARDS: Array<{ code: string; roleClass: string }> = [
  { code: '3D', roleClass: 'fan-card-opener' },
  { code: 'TS', roleClass: 'fan-card-combo-1' },
  { code: 'JS', roleClass: 'fan-card-combo-2' },
  { code: 'QS', roleClass: 'fan-card-combo-3' },
  { code: 'KS', roleClass: 'fan-card-combo-4' },
  { code: 'AS', roleClass: 'fan-card-combo-5' },
  { code: '2S', roleClass: 'fan-card-boss' },
];

export function LandingHero({ children }: LandingHeroProps) {
  const { lang, t } = useI18n();
  const isMn = lang === 'mn';

  return (
    <section className="landing-hero" id="hero" aria-label={isMn ? 'Эхлэл хэсэг' : 'Hero section'}>
      <div className="landing-hero-content">
        <div className="landing-badge">
          <span className="landing-badge-suit" aria-hidden="true">♠</span>
          <span>{t.landingHeroBadge}</span>
        </div>

        <h1 className="landing-hero-title">
          <span className="landing-hero-title-main">{isMn ? 'Арван гурав' : 'Big Two'}</span>{' '}
          <span className="landing-hero-title-sub">
            {isMn ? 'Онлайн Хөзрийн Тоглоом' : '(Arvan Gurav) Online'}
          </span>
        </h1>

        <p className="landing-hero-subtitle">{t.landingHeroSubtitle}</p>

        {/* Signature Big Two Table Visual */}
        <div className="hero-big2-stage" aria-hidden="true">
          <div className="hero-card-fan">
            {HERO_FAN_CARDS.map(({ code, roleClass }) => (
              <div key={code} className={`hero-fan-slot ${roleClass}`}>
                <CardUI cardCode={code} />
              </div>
            ))}
          </div>
        </div>

        <div className="landing-trust-grid" aria-label={isMn ? 'Үндсэн давуу талууд' : 'Highlights'}>
          <div className="landing-trust-item">
            <span className="landing-trust-suit" aria-hidden="true">♠</span>
            <strong>{t.landingTrustInstantSub}</strong>
          </div>
          <div className="landing-trust-item">
            <span className="landing-trust-suit" aria-hidden="true">♣</span>
            <strong>{t.landingTrustBotsSub}</strong>
          </div>
          <div className="landing-trust-item">
            <span className="landing-trust-suit is-red" aria-hidden="true">♦</span>
            <strong>{t.landingTrustRoomsSub}</strong>
          </div>
          <div className="landing-trust-item">
            <span className="landing-trust-suit is-red" aria-hidden="true">♥</span>
            <strong>{t.landingTrustTsaiSub}</strong>
          </div>
        </div>
      </div>
      {children}
    </section>
  );
}
